import * as React from "react";
import smile1 from "../../../../assets/images/icon-smile.svg"
import smile2 from "../../../../assets/images/icon-smile2.svg"
import smile3 from "../../../../assets/images/icon-smile3.svg"
import smile4 from "../../../../assets/images/icon-smile4.svg"
import Badge from "./Badge";


const StudentRow = ({ index, name, number, stageResult, resultTags}) => {
    const getSmileIcon = (accuracy) => {
        if (accuracy === null || accuracy === undefined) {
            return smile4; // 회색 스마일
        } else if (accuracy >= 90) {
            return smile1; // 파란 스마일
        } else if (accuracy >= 70) {
            return smile2; // 초록 스마일
        } else {
            return smile3; // 빨강 스마일
        }
    };

    const getTextColor = (accuracy) => {
        if (accuracy === null || accuracy === undefined) {
            return "text-gray-400"; // 회색 글씨
        } else if (accuracy >= 90) {
            return "text-blue-500"; // 파란 글씨
        } else if (accuracy >= 70) {
            return "text-green-500"; // 초록 글씨
        } else {
            return "text-red-500"; // 빨강 글씨
        }
    };

    // 초를 기반으로 시간을 포맷하는 함수
    const formatTime = (seconds) => {
        if (seconds < 60) {
            return `${seconds}초`; // 60초 미만
        } else if (seconds < 3600) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = seconds % 60;
            return `${minutes}분 ${remainingSeconds}초`; // 60초 이상 3600초 미만 (1시간 미만)
        } else {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            return `${hours}시간 ${minutes}분`; // 3600초 이상 (1시간 이상)
        }
    };

    const accuracy = stageResult?.accuracy || null;
    const time = stageResult?.time || null;

    return (
        <tbody>
                <tr
                    className="flex flex-wrap items-center text-base font-semibold rounded-xl min-h-[100px] max-md:max-w-full">
                    <td
                        className="flex flex-col justify-center  self-stretch px-2 align-middle text-center whitespace-nowrap text-slate-400 w-[60px] border-l-[1px] border-r-[1px] border-b-[1px] border-gray-200">
                        {number}
                    </td>
                    <td
                        className="line-clamp-4 justify-center px-2 whitespace-pre-wrap text-zinc-500 w-[90px] border-r-[1px] border-b-[1px] border-gray-200 h-[108px] flex items-center">
                        {name}
                    </td>
                    <td
                        className="flex flex-col justify-center self-stretch px-2 min-h-[104px] text-zinc-500 w-[120px] border-r-[1px] border-b-[1px] border-gray-200">
                        {stageResult && stageResult.studyDateTime ? stageResult.studyDateTime : "-"}
                    </td>
                    <td
                        className="flex flex-col justify-center self-stretch px-2 min-h-[104px] text-zinc-500 w-[150px] border-r-[1px] border-b-[1px] border-gray-200">
                        {stageResult && stageResult.studyDateTime ? (
                            <div
                                className="w-[124px] h-[35px] px-[18px] py-2 bg-[#eef6ff] rounded-[100px] justify-center items-center gap-2 inline-flex">
                                <div className="w-1.5 h-1.5 bg-[#7394ff] rounded-full"/>
                                <div className="text-center text-[#7394ff] text-base font-semibold font-['Inter']">학습 완료
                                </div>
                            </div>
                        ) : (
                            <div
                                className="w-[124px] h-[35px] px-[18px] py-2 bg-[#f6f6f6] rounded-[100px] justify-center items-center gap-2 inline-flex">
                                <div className="w-1.5 h-1.5 bg-[#b0b2b8] rounded-full"/>
                                <div
                                    className="text-center text-[#b0b2b8] text-base font-semibold font-['Inter']">미완료
                                </div>
                            </div>
                        )}
                    </td>
                    <td
                        className="flex flex-col justify-center self-stretch whitespace-nowrap min-h-[104px] text-zinc-500 w-[110px] border-r-[1px] border-b-[1px] border-gray-200">
                        {time !== null ? formatTime(time) : "-"}
                    </td>
                    <td
                        className="flex flex-col gap-1 justify-center items-center self-stretch px-2 text-sm tracking-tighter text-center whitespace-nowrap min-h-[104px] w-[100px] border-r-[1px] border-b-[1px] border-gray-200"
                    >
                        <img
                            src={getSmileIcon(accuracy)}
                            alt="accuracy smile"
                            className="w-8 h-8" // 아이콘 크기 조정
                        />
                        <span className={`font-semibold ${getTextColor(accuracy)}`}>
                            {accuracy !== null ? `${accuracy}%` : "-"}
                        </span>
                    </td>
                    <td
                        className="flex flex-col justify-center self-stretch px-[14px] min-h-[108px] text-zinc-500 w-[360px] border-r-[1px] border-b-[1px] border-gray-200 items-center text-xs font-medium text-center ">
                        <div className="flex flex-col justify-center items-center self-stretch my-auto min-w-[240px]">
                            <div className="flex gap-2.5 items-center flex-wrap">
                                {resultTags.map((tag, index) => (
                                    <Badge key={index} text={tag} />
                                ))}
                            </div>
                        </div>
                    </td>
                </tr>
        </tbody>
    );
}

export default StudentRow;